import { type SVGProps } from "react"
import { IconBase } from "./IconBase"

export function FahrbatterieEvfIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props} viewBox="0 0 235 170">
      <path
        stroke="currentColor"
        stroke-linecap="square"
        stroke-width="10"
        d="M220 55v100M40 155h180M205 40v100M25 140h180"
      />
      <path d="M30 5h35v20H30zM135 5h35v20h-35z" />
      <path
        fill="#fff"
        stroke="currentColor"
        stroke-width="10"
        d="M10 25h180v100H10z"
      />
      <path d="M35 70h40v10H35zM125 70h40v10h-40z" />
      <path d="M140 55h10v40h-10z" />
    </IconBase>
  )
}
